/**
 * Created by UI/UX Team on 2018. 2. 14..
 */
var errMsg = require('./errMsg');

module.exports = {
	appName: 'EIMS',
    title: 'EIMS',
    url: {
    	validateUser: 'server/user...'
    },
	errMsg: errMsg
};


//////////////////
// WEBPACK FOOTER
// ./src/environments/env.js
// module id = d23ec9fea562180d49fc
// module chunks = app/app.config app/common/service/http.service app/views/SCR0001/SCR0001.controller